import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'mj-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit, OnDestroy {
  @Input() extended: boolean;
  @Output() search: EventEmitter<any> = new EventEmitter<any>();
  form: any;
  formSub$: any;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      search: '',
    });

    this.formSub$ = this.form
      .get('search')
      .valueChanges.pipe(debounceTime(400))
      .subscribe(val => {
        this.searchListings(val);
      });
  }

  ngOnDestroy() {
    if (this.formSub$) {
      this.formSub$.unsubscribe();
    }
  }

  searchListings(val: any) {
    this.search.emit(val);
  }

  clearForm() {
    this.form.patchValue({
      search: '',
    });
  }

  toggleExtended() {
    this.extended = !this.extended;
  }
}
